<template>
  <section v-loading.fullscreen.lock="loading">
    <div class="school">
      <div class="school-title" />
      <div v-if="info" class="school-content">
        <el-form
          ref="info"
          :model="info"
          status-icon
          label-position="left"
          label-width="100px"
        >
          <div class="imgbox">
            <!-- <img :src="info.logo" alt=""> -->
            <el-upload
              class="avatar-uploader"
              :action="action"
              :show-file-list="false"
              :class="{isShow:info.logo}"
              accept=".jpg,.jpeg,.png"
              :on-success="handleAvatarSuccess"
            >
              <img v-if="info.logo" :src="info.logo" class="avatar">
              <i v-else class="el-icon-plus avatar-uploader-icon" />
            </el-upload>
          </div>
          <div class="imgbox">
            {{ info.school_name }}
          </div>

          <!-- <el-form-item prop="content" label="基本信息:">
            <div class="myEditor">
              <com-editor v-model="info.content" />
            </div>
          </el-form-item> -->
          <!-- <el-form-item class="grayWord" label="手机号">
            <span class="sjh">{{ user.phone }}</span>
            <span class="sel" @click="handleEdit">修改</span>
          </el-form-item> -->
          <!-- <el-form-item class="grayWord" label="微信">
            <span class="sjh">{{ user.wx_nickname }}</span>
            <span v-if="user.wx_nickname" class="sjh">已绑定</span>
            <span v-else class="sel" @click="handleBind">去绑定</span>
          </el-form-item> -->
          <el-form-item class="grayWord" label="密码:">
            <el-button type="text" @click="passwordShow=true">
              修改
            </el-button>
          </el-form-item>
          <el-form-item class="grayWord" label="联系电话:">
            <el-input v-model="info.phone" class="lxdh" />
          </el-form-item>
          <el-form-item class="grayWord mt" label="地址:">
            <el-input v-model="info.address" class="dz" />
          </el-form-item>

          <el-form-item class="uploadPhoto content" label="上传图片:">
            <span>（注：支持jpg/png格式，不超过5M，最多上传9张）</span>
            <div class="uploadBox">
              <com-upload v-model="imgList" :action="imgAction" :limit="9" />
            </div>
          </el-form-item>
          <el-form-item class="grayWord tinymcBox" label="学校简介:">
            <Tinymce
              v-model="info.content"
            />
          </el-form-item>
        </el-form>
      </div>
      <div class="school-btns">
        <el-button
          type="text" class="btn1" @click="handleSubmit"
        >
          提交
        </el-button
        >
      </div>
    </div>
    <com-wx-phone
      v-model="wxPhoneAdd.show"
      :rules="mineInfo.obj.wxRules"
      @input="init"
    />
    <com-phone-edit
      v-model="phoneEdit.show"
      @input="init"
    />
    <el-dialog
      id="login_container"
      title=""
      :visible.sync="wxShow"
      :close-on-click-modal="false"
      width="30%"
      :before-close="ai_dialog_close"
    >
      <iframe
        :src="urltest"
        frameborder="0"
        width="100%"
        height="400px"
        scrolling="auto"
      />
    </el-dialog>
    <EditPassword
      v-if="passwordShow"
      @close="passwordShow=false"
    />
  </section>
</template>


<script>
// import WxLogin from "vue-wxlogin";
import mock from '@/utils/mock'
import api from '@/api/app'
import comUpload from '@/components/comUpload'
import comEditor from '@/components/comEditor.vue'
import comWxPhone from './comWxPhone.vue'
import comPhoneEdit from './comPhoneEdit.vue'
import EditPassword from '@/views/mine/set/details/comSchool/EditPassword'
import Tinymce from '@/components/Tinymce'

import { getToken } from '@/utils/auth'
import { mapGetters } from 'vuex'
export default {
  name: 'ComSchool',
  components: {
    comUpload,
    // comEditor,
    comWxPhone,
    comPhoneEdit,
    EditPassword,
    Tinymce
  },
  props: {
    value: Boolean,
    id: Number,
    rules: {
      type: Object,
      default: () => {
        return {}
      }
    }
  },
  computed: {
    imgAction() {
      return `${process.env.VUE_APP_BASE_API}api/uploadFile`
    },
    ...mapGetters({
      user: 'user/user'
    }),
    action() {
      return `${process.env.VUE_APP_BASE_API}api/uploadFile`
    }
  },
  data() {
    return {
      bind: false,
      imgUrl: null,
      isSendCode: false,
      codeText: '发送验证码',
      dialogVisible: false,
      info: null,
      loading: false,
      mineInfo: mock.mine.set.viewInfo,
      mineInit: mock.mine.set.init,
      imgList: null,
      requestParams: {
        school_id: null
      },
      wxPhoneAdd: {
        show: false,
        id: null
      },
      phoneEdit: {
        show: false,
        id: null
      },
      inform: {
        Authorization: null,
        phone: '',
        code: ''
      },
      info1: {
        phone: null,
        captcha: null,
        key: null
      },
      wxShow: false,
      urltest: '',
      bindPhone: false,
      bindWx: false,
      editPhone: false,
      zhmm: false,
      pwd: null,
      newset: false,
      edit: {
        pwd: null,
        newpwd: null,
        ensure: null
      },
      passwordShow: false
    }
  },
  watch: {
    imgList: {
      handler(val) {
        // this.info.cover_img = val.length ? val[0].url : "";
        // this.info.img_urls = val.length ? val[0].url : ""
      }
    }
  },
  mounted() {
    this.loading = true
    this.init()
    const oScript = document.createElement('script')
    oScript.type = 'text/javascript'
    oScript.src = 'http://res.wx.qq.com/connect/zh_CN/htmledition/js/wxLogin.js'
    document.body.appendChild(oScript)
    var name = JSON.parse(localStorage.getItem('user')).username
    var pwd = JSON.parse(localStorage.getItem('accountObj'))[name]
    this.pwd = pwd
  },
  methods: {
    handleEnsure(v) {
      if (v !== this.edit.newpwd) {
        this.$message.error('两次输入的密码不一致')
      } else {
        var obj = {}
        obj.password = this.edit.pwd
        obj.new_password = this.edit.newpwd
        obj.new_password_1 = this.edit.ensure
        api.system.resetpwd(obj).then((res) => {
          console.log(obj)
          console.log(res)
        }).catch(() => {

        })
      }
    },
    handlepwd(v) {
      console.log(v)
      console.log(this.pwd)
      if (v !== this.pwd) {
        this.$message.error('您输入的密码有误')
        this.info.pwd = null
        this.newset = false
      } else {
        this.newset = true
      }
    },
    handleEdit(v) {
      if (v == 'phone') {
        this.phoneEdit.show = true
      }
      if (v == 'zhmm') {
        this.zhmm = true
      }
    },
    handleBind() {
      this.handleWxLogin()
      this.wxShow = true
    },
    handleControl(v, x) {
      api.system.mode().then((res) => {
        if (res.data.wx == 1 && res.data.phone == 0) {
          this.wxPhoneAdd.show = true
          this.wxPhoneAdd.id = null
        } else if (res.data.wx == 0 && res.data.phone == 1) {
          this.handleWxLogin()
          this.wxShow = true
        } else if (res.data.wx == 1 && res.data.phone == 1) {
          this.wxPhoneAdd.show = false
          this.phoneEdit.show = true
        } else {
          //  this.$message("该用户已绑定");
        }
      })
      this.$emit('control', v, x)
    },
    // handleWxLogin() {
    //   const obj1 = {}
    //   obj1.type = 3
    //   obj1.token = getToken()
    //   api.system.wx(obj1).then((res) => {
    //     console.log(res)
    //     const APPID = res.data.appid
    //     const REDIRECT_URI = res.data.redirect_uri
    //     const STATE = res.data.state
    //     this.urltest = `https://open.weixin.qq.com/connect/qrconnect?appid=${APPID}&redirect_uri=${REDIRECT_URI}&response_type=code&scope=snsapi_login&state=${STATE}#wechat_redirect`
    //     var obj = new WxLogin({
    //       self_redirect: false,
    //       id: 'login_container',
    //       appid: APPID,
    //       scope: 'snsapi_login',
    //       redirect_uri: REDIRECT_URI,
    //       state: STATE,
    //       style: 'black',
    //       href: ''
    //     })
    //   })
    // },
    async init() {
      this.requestParams.school_id = this.id
      this.info = await this.mineInit.data3(this.requestParams)
      const obj = {
        id: 1,
        type: 'img'
      }
      obj.url = this.info.cover_img
      // this.imgList = this.info.cover_img ? [obj] : [];
      this.imgList = this.info.img_urls.map((item, index) => {
        return { url: item }
      })
      console.log(this.imgList)
      this.loading = false
      api.system.mode().then((res) => {
        if (res.data.wx == 1 && res.data.phone == 0) {
          this.bindPhone = true
        } else if (res.data.wx == 0 && res.data.phone == 1) {
          this.bindWx = true
        } else if (res.data.wx == 1 && res.data.phone == 1) {
          this.editPhone = true
        } else {
          //  this.$message("该用户已绑定");
        }
      })
    },
    handleSubmit() {
      this.loading = true
      this.info.school_id = this.id
      this.info.img_urls = this.imgList.map((item, index) => {
        return item.url
      })
      console.log(this.info.content)
      api.school.update.info(this.info).then((res) => {
        this.$message.success('修改成功')
        this.loading = false
        this.init()
      }).catch(() => {
        this.loading = false
      })

      // this.cancelSubmit()
    },
    handleAvatarSuccess(res) {
      this.info.logo = res.data[0]
    },
    // cancelSubmit() {
    //   this.$emit('input')
    // },
    ai_dialog_close() {
      this.wxShow = false
    }
  }
}
</script>
<style>
  .avatar-uploader .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
  }
  .isShow .el-upload{
    border: none;
  }
  .avatar-uploader .el-upload:hover {
    border-color: #409EFF;
  }
  .avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 178px;
    height: 178px;
    line-height: 178px;
    text-align: center;
  }
  .avatar {
    width: 178px;
    height: 178px;
    display: block;
    border-radius:50%;
    object-fit: contain;
    background-color: #f4f4f4;
  }


</style>
<style scoped lang="scss">

.school {
  // overflow: hidden;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  &-title {
    width: 100%;
    height: 50px;
    display: flex;
    justify-content: space-between;
    font-weight: bold;
  }
  &-content {
    flex: 1;
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    overflow: hidden;
    .mt {
      margin-top: 10px;
    }
    .sel {
      color: #d3713b;
      cursor: pointer;
    }
    .sjh {
      margin-right: 15px;
    }
    .lxdh {
      width: 150px;
    }
    .dz {
      width: 88%;
    }
    .xxjj {
      height: auto !important;
    }
    .pl10{
      padding-left: 10px;
      margin: 10px 0;
    }
    .content{
      height: auto !important
    }
    .myEditor {
      height: 50px;
    }
    .uploadPhoto {
      border-bottom: 1px solid #f6f6f6;
      margin-top: 40px;
    }
    .imgbox {
      display: flex;
      justify-content: center;
      margin-bottom: 16px;
      > img {
        width: 130px;
        height: 130px;
        border: 1px solid #999;
        border-radius: 50%;
        overflow: hidden;
        object-fit: cover;
      }
    }
  }
  &-btns {
    width: 100%;
    height: 50px;
    display: flex;
    justify-content: center;
    > button {
      height: 40px;
      line-height: 40px;
      width: 100px;
      padding: 0;
      @include fun-design(4);
      @include fun-border();
      &:nth-child(1) {
        background-color: #2f82ff;
        border: 0;
        color: #fff;
      }
    }
  }
}
.wxPhone {
  padding-left: 10px;
  border: 0;
  background: none;
  cursor: pointer;
  color: #2f82ff;
}
</style>
<style scoped lang="scss">
.school-content /deep/.el-form-item {
  margin-bottom: 0;
  text-align: center;
  // height: 50px;
  // line-height: 50px;
}
.school-content /deep/ .el-form {
  width: 100%;
  margin-bottom: 30px;
  .el-form-item__label {
    text-align: right;
    margin-right: 10px;
  }
  .el-form-item__content {
    text-align: left;
  }
}
.school-content /deep/ .el-input__inner {
  border: none;
  background-color: #f4f4f4;
}
.school-content /deep/ .el-textarea__inner {
  border: none;
  background-color: #f4f4f4;
  resize: none;
}
 /deep/ .el-form-item__label {
  color: #bbb;
}
.uploadPhoto /deep/ .upload {
  margin: 10px 40px;
}
// .uploadPhoto /deep/ .upload-drag-item{
//     width: 239px !important;
//     height: 181px !important;
//   }
.uploadBox{
  // padding-left: 108px;
}

</style>d
